<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :default-active="activeMenuPath"
      :collapse="isCollapse"
      :unique-opened="systemConfig?.uniqueOpened === '1'"
      :collapse-transition="false"
      mode="vertical"
    >
      <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" />
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from "vuex"
import SidebarItem from "./sidebarItem"
import variables from "@/styles/app-variables.scss"

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      "openSidebar",
      "systemConfig"
    ]),
    routes() {
      const dynamicRoute = window.configObj.dynamicRoute || process.env.VUE_APP_DYNAMIC_ROUTE
      if (dynamicRoute === "1") { //动态添加路由
        return this.$store.state.user.sidebarMenuTree
      } else {
        return this.$router.options.routes
      }
    },
    activeMenuPath() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenuPath) {
        return meta.activeMenuPath
      }
      return path
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.openSidebar
    }
  }
}
</script>
<style lang="scss" scoped>
.scrollbar-wrapper{
  width: 100%;
}
</style>
